<template>
  <div class="sub-main">
    <div class="breadcrumb">
      <a href="javascript:" class="back" @click="routeBack()">
        <i class="iconfont iconshuangzuojiantou-"></i>返回
      </a>
      <ul>
        <li v-for="item in breadcrumbs" :key="item.name">{{item.name}}</li>
      </ul>
    </div>
    <div class="sub-main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    breadcrumbs() {
      return this.$route.meta.breadcrumbs || []
    }
  }
}
</script>
